import { NfColumnTypes } from '@northfork/ag-grid'
import {
  AngularColumnTypeEnum,
  FilterOptionDef,
} from '@northfork/ag-grid-angular'
import {
  ColDef,
  ICellRendererParams,
  ITooltipParams,
} from '@ag-grid-community/core'
import {
  generateMdiIcon,
  HeliosColumnTypes,
  heliosColumnTypes,
  heliosDefaultColWidth,
} from '@helios/ag-grid-config'
import { TransactionMatchCountColDef } from './transaction-match-count'

export enum ClearwaterTransactionColumnTypes {
  /** Ag-grid column type that formats number of transaction matches PVAL-13837 */
  TransactionMatchCount = 'TransactionMatchCount',
}

/** Default column type definitions for the clearwater transactions grid. */
export const clearwaterTransactionColumnTypes: Record<
  | ClearwaterTransactionColumnTypes
  | HeliosColumnTypes
  | NfColumnTypes
  | AngularColumnTypeEnum
  | string,
  ColDef
> = {
  ...heliosColumnTypes,
  [ClearwaterTransactionColumnTypes.TransactionMatchCount]:
    TransactionMatchCountColDef,
}
